import {
  Table,
  TableCell,
  TableRow,
  Paragraph,
  TextRun,
  WidthType,
  AlignmentType,
  BorderStyle,
  ShadingType,
} from "docx";

const renditjaMuajve = [
  "Janar",
  "Shkurt",
  "Mars",
  "Prill",
  "Maj",
  "Qershor",
  "Korrik",
  "Gusht",
  "Shtator",
  "Tetor",
  "Nëntor",
  "Dhjetor",
];

const emratTV = ["Top Channel", "Klan", "Rtsh 1", "Vizion Plus"];

const borderAll = {
  top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
  bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
  left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
  right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
};

const getStyledCell = (text, opts = {}) => {
  const {
    bold = false,
    fontSize = 20, // 20 = 10pt
    color = "000000",
    align = AlignmentType.CENTER,
    shading,
    colSpan,
    rowSpan,
  } = opts;

  return new TableCell({
    columnSpan: colSpan,
    rowSpan,
    margins: { top: 100, bottom: 100, left: 100, right: 100 },
    borders: borderAll,
    shading,
    children: [
      new Paragraph({
        alignment: align,
        children: [
          new TextRun({
            text: String(text),
            bold,
            color,
            size: fontSize,
            font: "Arial",
          }),
        ],
      }),
    ],
  });
};

export function ModelWorldReklmaSekonda(data) {
  const getValue = (muaji, tvName, field) => {
    const tvData = data[muaji]?.find(
      (d) => d.TV.trim().toLowerCase() === tvName.toLowerCase()
    );
    return tvData ? tvData[field] : "-";
  };

  const headerBlue = {
    type: ShadingType.CLEAR,
    color: "auto",
    fill: "f44336", // blu
  };

  // Headeri i parë (muaji dhe TV-të)
  const headerRow1 = new TableRow({
    children: [
      getStyledCell("Muaji", {
        bold: true,
        fontSize: 22,
        color: "FFFFFF",
        rowSpan: 2,
        shading: headerBlue,
      }),
      ...emratTV.map((tv) =>
        getStyledCell(tv, {
          bold: true,
          fontSize: 22,
          color: "FFFFFF",
          colSpan: 2,
          shading: headerBlue,
        })
      ),
    ],
  });

  // Headeri i dytë (sub-kolonat)
  const headerRow2 = new TableRow({
    children: emratTV.flatMap(() => [
      getStyledCell("Koha në sekonda", {
        bold: true,
        fontSize: 20,
        color: "FFFFFF",
        shading: headerBlue,
      }),
      getStyledCell("Nr.i Reklamave", {
        bold: true,
        fontSize: 20,
        color: "FFFFFF",
        shading: headerBlue,
      }),
    ]),
  });

  // Të dhënat për çdo muaj
  const bodyRows = renditjaMuajve.map((muaji) => {
    return new TableRow({
      children: [
        getStyledCell(muaji, { bold: true }),
        ...emratTV.flatMap((tv) => [
          getStyledCell(getValue(muaji, tv, "Koha në sekonda")),
          getStyledCell(getValue(muaji, tv, "Nr.i Reklamave")),
        ]),
      ],
    });
  });

  return [
    new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [headerRow1, headerRow2, ...bodyRows],
    }),
  ];
}

export default ModelWorldReklmaSekonda;
